module.exports = __webpack_public_path__ + "img/logo-giser.fb6d89cf.png";